<template>
    <div class="centerMenu">
        <ul>
            <li :class="{'active' : active == 1}"><router-link to="/center/userInfo">账号信息</router-link></li>
            <li :class="{'active' : active == 2}"><router-link to="/center/mypay">我的支付</router-link></li>
            <li :class="{'active' : active == 3}"><router-link to="/center/mysignup">我的报名</router-link></li>
            <li :class="{'active' : active == 4}"><router-link to="/center/myexam">我的考试</router-link></li>
            <li :class="{'active' : active == 5}"><router-link to="/center/myCertification">我的再认证</router-link></li>
            <!-- <li :class="{'active' : active == 6}"><router-link to="/center/mycertificate">我的电子证书</router-link></li> -->
            <li :class="{'active' : active == 7}"><router-link to="/center/dynamicMessage">我的通知</router-link></li>
			<li :class="{'active' : active == 8}"><router-link to="/center/questionsAnswers">我的问答</router-link></li>
            <li :class="{'active' : active == 9}"><router-link to="/center/myPaper">我的论文</router-link></li>
        </ul>
    </div>
</template>

<script>
export default {
    name: "centerMenu",
    data(){
        return {
            
        }
    },
    props:{
        active:{
            type: String,
            default: '1'
        }
    },
    methods:{
        
    }
}
</script>

<style scoped>
    .centerMenu li{line-height: 44px;}
    .centerMenu li.active>a{color: #b92f20;}
</style>